import { storeToRefs } from 'pinia';

import { useUserRole } from '@/shared/composables/useUserRole';
import { LEGAL_DOCUMENTS_ACCEPTED } from '@/shared/constants';
import { useAuthStore } from '@/store/authStore';
import { useLegalDocumentsStore } from '@/store/documents';

export const useLegalDocuments = () => {
  const { isAgent } = useUserRole();
  const authStore = useAuthStore();
  const { isAggregator } = storeToRefs(authStore);

  const legalDocumentsStore = useLegalDocumentsStore();
  const { acceptedDocuments, acceptedDocumentsV2 } = storeToRefs(legalDocumentsStore);

  const acceptedLegalDocuments = (slugs: Array<string>) => {
    return acceptedDocuments.value
      .filter(({ documentSlug, isAccepted }) => {
        return slugs.includes(documentSlug) && !isAccepted;
      })
      .map(({ documentSlug }) => documentSlug);
  };

  const acceptedLegalDocumentsV2 = () => {
    return acceptedDocumentsV2.value.map((item) => item.documentSlug);
  };

  /**
   * Список слагов для принятых документов в зависимости от роли
   * @param {boolean } withCookies добавляем в список слаг документа принятия cookies
   *
   * @returns Список слагов
   */
  const documentsSlugsWithRole = (withCookies?: boolean) => {
    const documentsSlugs = isAgent
      ? LEGAL_DOCUMENTS_ACCEPTED.agent
      : isAggregator.value
        ? LEGAL_DOCUMENTS_ACCEPTED.aggregator
        : LEGAL_DOCUMENTS_ACCEPTED.repres;

    if (withCookies) {
      return [
        ...documentsSlugs,
        ...LEGAL_DOCUMENTS_ACCEPTED.cookies,
      ];
    }

    return documentsSlugs;
  };

  return {
    acceptedLegalDocuments,
    acceptedLegalDocumentsV2,
    documentsSlugsWithRole,
  };
};
